import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Newsletter from "./Newsletter";

function NewsletterSection(props) {
  return (
    <Section
      bgcolor={props.bgcolor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={4}
        >
          <Grid xs={12} md={6}>
            <SectionHeader
              title={props.title}
              subtitle={props.subtitle}
              size={4}
            />
          </Grid>
          <Grid xs={12} md={6}>
            <Newsletter
              buttonText={props.buttonText}
              buttonColor={props.buttonColor}
              inputPlaceholder={props.inputPlaceholder}
              subscribedMessage={props.subscribedMessage}
            />
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
}

export default NewsletterSection;
